import { ArrowRight, Pencil, Upload } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

type Mode = 'upload' | 'update'

interface ModeChooserProps {
  onSelect: (mode: Mode) => void
}

const ModeChooser = ({ onSelect }: ModeChooserProps) => (
  <div className="mt-6 flex gap-4">
    <Card
      onClick={() => onSelect('upload')}
      className="group flex-1 cursor-pointer rounded-2xl border-border bg-white transition-colors hover:bg-accent"
    >
      <CardContent className="flex items-center gap-5 p-6">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-rexBlue-600 text-white">
          <Upload className="h-5 w-5" />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-base font-bold text-foreground">Upload element dataset</span>
          <span className="text-sm text-muted-foreground">
            Add a new dataset by uploading a file
          </span>
        </div>
        <ArrowRight className="ml-auto h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-1" />
      </CardContent>
    </Card>

    <Card
      onClick={() => onSelect('update')}
      className="group flex-1 cursor-pointer rounded-2xl border-border bg-white transition-colors hover:bg-accent"
    >
      <CardContent className="flex items-center gap-5 p-6">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-deepTeal text-white">
          <Pencil className="h-5 w-5" />
        </div>
        <div className="flex flex-col gap-1">
          <span className="text-base font-bold text-foreground">Update element dataset</span>
          <span className="text-sm text-muted-foreground">
            Edit the metadata of an existing dataset
          </span>
        </div>
        <ArrowRight className="ml-auto h-5 w-5 text-muted-foreground transition-transform group-hover:translate-x-1" />
      </CardContent>
    </Card>
  </div>
)

export default ModeChooser
